import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link as MuiLink } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { getAdditionalLinkAttributes } from '@jelly/utils';

var getStyles = function getStyles(variation, theme) {
  var color;
  var hover;

  switch (variation) {
    case 'primary':
      color = theme.palette.primary.main;
      hover = theme.palette.secondary.main;
      break;

    case 'tertiary':
      color = theme.palette.tertiary.main;
      hover = theme.palette.primary.main;
      break;

    case 'contentLink':
      color = theme.palette.link.content.main;
      hover = theme.palette.secondary.main;
      break;

    case 'authorLink':
      color = theme.palette.text.primary;
      hover = theme.palette.link.author.hover;
      break;

    case 'breadcrumb':
      color = theme.palette.grey[600];
      hover = theme.palette.link.breadcrumb.main;
      break;

    case 'light':
      color = theme.palette.common.white;
      hover = theme.palette.secondary.main;
      break;

    case 'secondary':
    default:
      color = theme.palette.secondary.main;
      hover = theme.palette.tertiary.main;
      break;
  }

  return {
    color: color,
    hover: hover
  };
};

var LinkWrapper = withStyles(function (theme) {
  return {
    root: {
      color: function color(_ref) {
        var variation = _ref.variation;
        return getStyles(variation, theme).color;
      },
      '&:hover': {
        color: function color(_ref2) {
          var variation = _ref2.variation;
          return getStyles(variation, theme).hover;
        }
      }
    }
  };
}, {
  name: 'linkWrapper'
})(MuiLink);

/**
 * Link - common component

 * @param {Node} props.children :: what the link should wrap
 * @param {String} props.string :: url path the link is directed to
 * @param {String} props.variant :: determines what type of theme the text or button link should display
 * any other prop you want
 *
 * Additionally, it features:
 * - a spread operator to handle relationship and target attributes
 *
 **/
export function Link(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      href = _ref3.href,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'primary' : _ref3$variant,
      restOfProps = _objectWithoutProperties(_ref3, ["children", "className", "href", "variant"]);

  var IS_GATSBY_SITE = process.env.GATSBY_ENABLE_GATSBY_LINKS === 'true'; // regex to check for exactly one leading slash

  var isInternal = /^\/(?!\/)/.test(href);
  var isGatsbyLink = isInternal && IS_GATSBY_SITE;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkWrapper, _extends({
    className: className,
    variation: variant,
    color: "inherit" // leave this for typography styles
    ,
    underline: "none"
  }, isGatsbyLink ? {
    to: href
  } : {
    href: href
  }, getAdditionalLinkAttributes(href), isGatsbyLink && {
    component: GatsbyLink
  }, restOfProps), children));
}
export default Link;